import { BaseSearchType } from '@baserow/modules/core/search/types/base'

export class HospitalitySearchType extends BaseSearchType {
  constructor(context = {}) {
    super(context)
    this.type = 'hospitality'
    this.name = 'Hospitality'
    this.icon = 'iconoir-bed'
    this.priority = 0
  }

  _hasRequiredMetadata(result) {
    const meta = result?.metadata || {}
    return !!(
      meta.database_id &&
      meta.table_id &&
      meta.row_id &&
      (meta.workspace_id || result?.workspaceId)
    )
  }

  buildUrl(result, context = null) {
    if (!this._hasRequiredMetadata(result)) {
      return null
    }
    const meta = result.metadata
    const workspaceId =
      meta.workspace_id ||
      context?.store?.getters?.['workspace/getSelectedId'] ||
      null
    if (!workspaceId) {
      return null
    }
    return {
      name: 'workspace-crm-table-row',
      params: {
        workspaceId,
        databaseId: meta.database_id,
        tableId: meta.table_id,
        rowId: meta.row_id,
      },
    }
  }

  isNavigable(result, context = null) {
    return this._hasRequiredMetadata(result)
  }

  getIcon() {
    return this.icon
  }
}
